import { useIsDemo } from '@/context/DemoContext';
import { toast } from 'sonner';
import { Info } from 'lucide-react';

/**
 * Shows a demo explainer toast when a demo user tries a write action.
 * Usage: const demoBlocked = useDemoGuard();
 *        if (demoBlocked('create and manage your own teams')) return;
 */
export function useDemoGuard() {
  const isDemo = useIsDemo();
  return (actionDescription) => {
    if (!isDemo) return false;
    toast(
      <div className="flex items-start gap-2.5">
        <Info className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" />
        <div>
          <p className="text-sm font-semibold text-slate-800">Demo Mode</p>
          <p className="text-xs text-slate-500 mt-0.5">
            In your own Coach's account, you can {actionDescription}.
          </p>
        </div>
      </div>,
      { duration: 4000 }
    );
    return true;
  };
}

/**
 * Inline demo banner for areas that are read-only.
 */
export function DemoBanner({ text }) {
  const isDemo = useIsDemo();
  if (!isDemo) return null;
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-lg mb-3 border"
      style={{ background: '#FFF8E8', borderColor: '#F5A623' }}
      data-testid="demo-banner">
      <Info className="w-4 h-4 text-amber-500 shrink-0" />
      <p className="text-xs text-amber-700">{text}</p>
    </div>
  );
}
